import { apyToApr } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const METH_URL = 'https://meth.mantle.xyz/api/stats/apy'

export const methFetcher: YieldFetcher = {
  label: 'METH',
  fetch: async () => {
    const res = await fetch(METH_URL).then((r) => r.json())
    const apr = apyToApr(Number(res.data[0]?.OneDayAPY)) * 100
    return { METH: apr, CMETH: apr }
  },
}
